module.exports = __webpack_public_path__ + "static/media/20.30b512e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/20.png
// module id = 1459
// module chunks = 0